import React, { useEffect, useRef,useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CaptiveModel.css";

// Images
import heroImage from "../../assets/captive-section-1.png";
import thumbImage from "../../assets/solar-thumb.png";
import solarPanelImage from "../../assets/solar-panel.png";
import solarGridImage from "../../assets/solar-grid.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import captiveFinancial1 from "../../assets/captivefinancial-1.png";
import captiveFinancial2 from "../../assets/captivefinancial-2.png";
import captiveFinancial3 from "../../assets/captivefinancial-3.png";
import captiveFinancial4 from "../../assets/captive-finance-3.png";
import captiveFinancial5 from "../../assets/captivefinancial-5.png";
import chooseImg from "../../assets/captive-whychoose.png";
import featuredproj1 from "../../assets/CIRsection6-1.png";
import featuredproj2 from "../../assets/CIRsection6-2.png";
// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
import IconManufacturers from "../../assets/Manufacturers.png";
import IconPharma from "../../assets/Pharma.png";
import IconTexiles from "../../assets/textiles.png";
import IconFMCG from "../../assets/FMCG.png";
import IconDataCenter from "../../assets/Data.png";
import IconWarehouse from "../../assets/Warehouse.png";
import IconAutomotive from "../../assets/Automotive.png";
import IconSteel from "../../assets/Steel.png";
import IconHospitality from "../../assets/Hospital.png";
import IconCement from "../../assets/cement.png";
import cps1step1 from "../../assets/CP-s1-step1.png";
import cps1step2 from "../../assets/CP-s1-step2.png";
import cps1step3 from "../../assets/CP-s1-step3.png";
import cps1step4 from "../../assets/CP-s1-step4.png";
import cps1step5 from "../../assets/CP-s1-step5.png";
import cps1step6 from "../../assets/CP-s1-step6.png";
import cps2step1 from "../../assets/CP-s2-step1.png";
import cps2step2 from "../../assets/CP-s2-step2.png";
import cps2step3 from "../../assets/CP-s2-step3.png";
import cps2step4 from "../../assets/CP-s2-step4.png";
import cps2step5 from "../../assets/CP-s2-step5.png";
import cps2step6 from "../../assets/CP-s2-step6.png";
import cps3step1 from "../../assets/CP-s3-step1.png";
import cps3step2 from "../../assets/CP-s3-step2.png";
import cps3step3 from "../../assets/CP-s3-step3.png";
import cps3step4 from "../../assets/CP-s3-step4.png";
import cps3step5 from "../../assets/CP-s3-step5.png";
import cps3step6 from "../../assets/CP-s3-step6.png";
import cps4step1 from "../../assets/CP-s4-step1.png";
import cps4step2 from "../../assets/CP-s4-step2.png";
import cps4step3 from "../../assets/CP-s4-step3.png";
import cps4step4 from "../../assets/CP-s4-step4.png";
import cps4step5 from "../../assets/CP-s4-step5.png";
import cps4step6 from "../../assets/CP-s4-step6.png";
import cps5step1 from "../../assets/CP-s5-step1.png";
import cps5step2 from "../../assets/CP-s5-step2.png";
import cps5step3 from "../../assets/CP-s5-step3.png";
import cps5step4 from "../../assets/CP-s5-step4.png";
import cps5step5 from "../../assets/CP-s5-step5.png";
import cps5step6 from "../../assets/CP-s5-step6.png";
import cps5step7 from "../../assets/CP-s5-step7.png";
import cps6step1 from "../../assets/CP-s6-step1.png";
import cps6step2 from "../../assets/CP-s6-step2.png";
import cps6step3 from "../../assets/CP-s6-step3.png";
import cps6step4 from "../../assets/CP-s6-step4.png";
import cps6step5 from "../../assets/CP-s6-step5.png";
import cps6step6 from "../../assets/CP-s6-step6.png";
import cps7step1 from "../../assets/CP-s7-step1.png";
import cps7step2 from "../../assets/CP-s7-step2.png";
import cps7step3 from "../../assets/CP-s7-step3.png";
import cps7step4 from "../../assets/CP-s7-step4.png";
import cps7step5 from "../../assets/CP-s7-step5.png";
import cps7step6 from "../../assets/CP-s7-step6.png";
import cps7step7 from "../../assets/CP-s7-step7.png";
import cps8step1 from "../../assets/CP-s8-step1.png";
import cps8step2 from "../../assets/CP-s8-step2.png";
import cps8step3 from "../../assets/CP-s8-step3.png";
import cps8step4 from "../../assets/CP-s8-step4.png";
import cps8step5 from "../../assets/CP-s8-step5.png";
import cps8step6 from "../../assets/CP-s8-step6.png";
import cps9step1 from "../../assets/CP-s9-step1.png";
import cps9step2 from "../../assets/CP-s9-step2.png";
import cps9step3 from "../../assets/CP-s9-step3.png";
import cps9step4 from "../../assets/CP-s9-step4.png";
import cps9step5 from "../../assets/CP-s9-step5.png";
import cps9step6 from "../../assets/CP-s9-step6.png";
import cps10step1 from "../../assets/CP-s10-step1.png";
import cps10step2 from "../../assets/CP-s10-step2.png";
import cps10step3 from "../../assets/CP-s10-step3.png";
import cps10step4 from "../../assets/CP-s10-step4.png";
import cps10step5 from "../../assets/CP-s10-step5.png";
import cps10step6 from "../../assets/CP-s10-step6.png";
import cps11step1 from "../../assets/CP-s11-step1.png";
import cps11step2 from "../../assets/CP-s11-step2.png";
import cps11step3 from "../../assets/CP-s11-step3.png";
import cps11step4 from "../../assets/CP-s11-step4.png";
import cps11step5 from "../../assets/CP-s11-step5.png";
import cps11step6 from "../../assets/CP-s11-step6.png";
import cps11step7 from "../../assets/CP-s11-step7.png";
import cps12step1 from "../../assets/CP-s12-step1.png";
import cps12step2 from "../../assets/CP-s12-step2.png";
import cps12step3 from "../../assets/CP-s12-step3.png";
import cps12step4 from "../../assets/CP-s12-step4.png";
import cps12step5 from "../../assets/CP-s12-step5.png";
import cps12step6 from "../../assets/CP-s12-step6.png";
import cps12step7 from "../../assets/CP-s12-step7.png";
// Icons
import { ReactComponent as IconEquity } from "../../assets/equity.svg";
import { ReactComponent as IconPower } from "../../assets/power.svg";
import { ReactComponent as IconSpv } from "../../assets/spv.svg";
import { ReactComponent as IconWheeling } from "../../assets/wheel.svg";

const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ======================================================
   SECTION 1 — HERO
====================================================== */
/* AFTER */
const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="cm-hero">
      <div className="cm-hero__orange-bg" />

      <div className="cm-hero__image-wrap">
        <img
          src={heroImage}
          alt="Solar panel workers"
          className="cm-hero__image"
        />
      </div>

      <div className="cm-hero__content">
        <h1 className="cm-hero__heading">
          Own Your Power. Reduce Tariffs. Secure Long-Term Stability.
        </h1>

        <p className="cm-hero__desc">
          Generate renewable power through structured equity ownership. True
          Renewables manages the entire captive framework—from regulatory
          compliance to long-term asset operations.
        </p>

        <div className="cm-cta">
          <button onClick={() => navigate("/contact")}>Book A Free Call</button>
        </div>

        <div className="cm-hero__thumb">
          <img src={thumbImage} alt="Solar installation" loading="lazy" />
        </div>
      </div>
    </section>
  );
};
/* ======================================================
   SECTION 2 — OVERVIEW (WORD-BY-WORD SCROLL)
====================================================== */
const OverviewSection = () => {
  const textRef = useRef();

  const text = `Under India's Electricity Act, a consumer holding minimum 26% equity and consuming 51% of the generated power qualifies as a captive user, unlocking exceptional financial benefits.`;

  useEffect(() => {
    const words = textRef.current.querySelectorAll(".word");

    const handleScroll = () => {
      const rect = textRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let progress = (windowHeight - rect.top) / windowHeight;
      progress = Math.max(0, Math.min(1, progress));

      const wordsToShow = Math.floor(progress * words.length);

      words.forEach((word, index) => {
        word.style.color = index < wordsToShow ? "#111" : "#6D6E70";
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="overview">
      <span className="overview__label">
        <span className="overview__dot" />
        OVERVIEW
      </span>

      <p ref={textRef} className="overview__text">
        {text.split(" ").map((word, index) => (
          <span key={index} className="word">
            {word}&nbsp;
          </span>
        ))}
      </p>
    </section>
  );
};

/* ======================================================
   SECTION 3 — CAPTIVE MODEL EXPLAINER
====================================================== */
const ExplainerSection = () => {
  return (
    <section className="captive-model">
      <div className="captive-model-container">
        <div className="captive-model__content">
          <div>
            <p className="captive-model__intro">
              In a captive solar model, a company invests in a solar project and
              directly consumes the generated power through an open access
              arrangement
            </p>

            <p className="captive-model__sub-heading">
              This allows businesses to achieve:
            </p>

            <ul className="captive-model__list">
              <li>Ultra-low landed electricity cost</li>
              <li>Zero Dependence on DISCOM tariff hikes</li>
              <li>Long-term price stability (25–30 years)</li>
              <li>Reduced carbon footprint & ESG compliance</li>
              <li>High ROI on equity investment</li>
            </ul>
          </div>

          <p className="captive-model__tagline">
            IT IS THE MOST PREFERRED MODEL FOR ENERGY-INTENSIVE INDUSTRIES AND
            MULTI-LOCATION CORPORATES.
          </p>
        </div>

        <div className="captive-model__image-wrap">
          <img
            src={solarPanelImage}
            alt="Solar panel installation"
            className="captive-model__image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

/* ======================================================
   SECTION 4 — REGULATORY CRITERIA
====================================================== */
const RegulatorySection = () => {
  const leftRef = useReveal();
  const rightRef = useReveal();

  return (
    <section className="regulatory-section">
      <div className="regulatory-left reveal-from-left" ref={leftRef}>
        <p className="regulatory-tag">
          <span className="testi-dot"></span> CAPTIVE COMPLIANCE
        </p>
        <h2 className="regulatory-title">
          Regulatory Criteria for Captive Qualification
        </h2>
        <p className="regulatory-desc">
          True Renewables manages all statutory, legal, and compliance
          requirements from stafinancial to finish
        </p>
      </div>
      <div className="regulatory-right" ref={rightRef}>
        {[
          {
            icon: IconEquity,
            title: "Equity Ownership",
            desc: "Captive user must hold ≥ 26% equity in the generating plant.",
          },
          {
            icon: IconPower,
            title: "Power Consumption",
            desc: "Captive user must consume ≥ 51% of the total generation annually.",
          },
          {
            icon: IconSpv,
            title: "SPV Formation Requirement",
            desc: "SPV (special purpose vehicle) is typically created for ownership.",
          },
          {
            icon: IconWheeling,
            title: "State-Level Wheeling & Banking Norms",
            desc: "Wheeling & banking norms vary by state.",
          },
        ].map((card, i) => (
          <div
            className="regulatory-card regulatory-card-animate"
            key={i}
            style={{ "--regulatory-delay": `${i * 0.1}s` }}
          >
            <div className="regulatory-card-icon-wrap">
              <card.icon className="regulatory-card-icon" />
            </div>
            <h4>{card.title}</h4>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ======================================================
   SECTION 5 — Financial Benefits
====================================================== */
const financialBenefitItems = [
  {
    title: "40–60% cheaper than grid power",
    desc: "Open access solar reduces per-unit cost drastically",
    image: captiveFinancial1,
  },
  {
    title: "Long-term tariff certainty",
    desc: "No escalation for 25 years; tariff remains constant.",
    image: captiveFinancial2,
  },
  {
    title: "High ROI on equity investment",
    desc: "ROI typically ranges from 16–22% depending on state policies.",
    image: captiveFinancial3,
  },
  {
    title: "Immediate savings from Year 1",
    desc: "Generation begins from the first month of commissioning.",
    image: captiveFinancial4,
  },
  {
    title: "Accelerated depreciation & tax benefits",
    desc: "Additional financial advantages based on corporate structure.",
    image: captiveFinancial5,
  },
];

const FinancialBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress — same pattern as HowItWorks. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          financialBenefitItems.length - 1,
          Math.floor(p * financialBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="financial-benefits-outer"
      ref={outerRef}
      style={{ height: `${financialBenefitItems.length * 110}vh` }}
    >
      <section className="financial-benefits-sticky">
        <div className="financial-benefits">
          {/* ── Centered header ── */}
          <div className="financial-benefits-header">
            <p className="financial-benefits-tag">
              <span className="financial-benefits-dot" />
              FINANCIAL BENEFITS
            </p>
            <h2 className="financial-benefits-title">
              Driven by Returns. Backed by Structure.
            </h2>
          </div>

          {/* ── Body: list left + image right ── */}
          <div className="financial-benefits-body">
            {/* Left benefit items */}
            <div className="financial-benefits-list">
              {financialBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`financial-benefit-item ${
                      i === activeIndex ? "financial-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                    onMouseEnter={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && (
                      <span className="financial-benefit-bar" />
                    )}

                    <div className="financial-benefit-text">
                      <p className="financial-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="financial-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="financial-benefit-mobile-img-wrap">
                    <div className="financial-benefit-mobile-img-bg" />
                    <img
                      src={item.image}
                      alt={item.title}
                      className="financial-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < financialBenefitItems.length - 1 && (
                    <hr className="financial-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            {/* Right image with blue offset block */}
            <div className="financial-benefits-img-wrap">
              <div className="financial-benefits-img-bg" />
              <img
                src={financialBenefitItems[activeIndex].image}
                alt={financialBenefitItems[activeIndex].title}
                className="financial-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

/* ================================================
   SECTION — WHO IT'S FOR (CAPTIVE)
   ================================================ */

const WHO_ITEMS = [
  { label: "Manufacturers", icon: IconManufacturers },
  { label: "Pharma", icon: IconPharma },
  { label: "FMCG", icon: IconFMCG },
  { label: "Textiles", icon: IconTexiles },
  { label: "Cement", icon: IconCement },
  { label: "Data Centers", icon: IconDataCenter },
  { label: "Warehousing & Logistics", icon: IconWarehouse },
  { label: "Automotive", icon: IconAutomotive },
  { label: "Steel & Fabrication", icon: IconSteel },
  { label: "Hospitality Chains", icon: IconHospitality },
];

const CaptiveWhoItsFor = () => {
  // split items into 2 rows
  const topRow = WHO_ITEMS.slice(0, 5);
  const bottomRow = WHO_ITEMS.slice(5);

  // duplicate for seamless loop
  const topTicker = [...topRow, ...topRow, ...topRow, ...topRow];
  const bottomTicker = [...bottomRow, ...bottomRow, ...bottomRow, ...bottomRow];

  return (
    <section className="captive-who-section">
      {/* Header */}
      <div className="captive-who-header">
        <p className="captive-who-tag">
          <span className="captive-who-dot" />
          IDEAL FOR
        </p>

        <h2 className="captive-who-title">
          Built for Energy-Intensive Industries
        </h2>

        <p className="captive-who-subtitle">
          For C&I consumers seeking tariff stability and long-term energy
          control.
        </p>
      </div>

      {/* Ticker */}
      <div className="captive-who-ticker">
        <div className="captive-who-track">
          {/* 🔹 TOP ROW → RIGHT */}
          <div className="captive-who-row captive-who-row-top">
            {topTicker.map((item, i) => (
              <div className="captive-who-card" key={`top-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="captive-who-card-icon"
                  loading="lazy"
                />
                <p className="captive-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>

          {/* 🔹 BOTTOM ROW → LEFT */}
          <div className="captive-who-row captive-who-row-bottom">
            {bottomTicker.map((item, i) => (
              <div className="captive-who-card" key={`bottom-${i}`}>
                <img
                  src={item.icon}
                  alt={item.label}
                  className="captive-who-card-icon"
                  loading="lazy"
                />
                <p className="captive-who-card-label">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 6 — HOW IT WORKS SECTION
   ================================================ */
const captiveStages = [
  {
    id: 1,
    title: "Load & Feasibility",
    steps: [
      { title: "Study of monthly, seasonal and peak vs off-peak consumption" , image: cps1step1},
      { title: "HT/LT load profile mapping" , image: cps1step2},
      { title: "Captive vs Group Captive suitability check" , image: cps1step3},
      { title: "Open access feasibility & grid constraints" , image: cps1step4},
      { title: "Ideal plant sizing (MW) based on consumption and regulatory caps" , image: cps1step5},
      { title: "Expected CUF and generation mapping against industrial load" , image: cps1step6},
    ],
  },
  {
    id: 2,
    title: "Financial Modelling",
    steps: [
      { title: "LCOE calculation (Levelized Cost of Energy)" , image: cps2step1},
      { title: "25-year tariff forecast (grid vs solar landed cost)" , image: cps2step2},
      { title: "Savings modelling (monthly & annual)" , image: cps2step3},
      { title: "IRR, payback & DSCR calculation" , image: cps2step4},
      { title: "Scenario modelling (CAPEX, OPEX, hybrid)" , image: cps2step5},
      { title: "Sensitivity analysis (load variation, OA charge variation)" , image: cps2step6},
    ],
  },
  {
    id: 3,
    title: "Land & Infra Check",
    steps: [
      { title: "Land identification, conversion & due diligence" , image: cps3step1},
      { title: "Topography, access roads & logistics assessment" , image: cps3step2},
      { title: "Evacuation feasibility: HT line length, ROW, substation PRA" , image: cps3step3},
      { title: "Substation loading capacity & bay availability" , image: cps3step4},
      { title: "Soil test, contour, MMS suitability" , image: cps3step5},
      { title: "Land procurement or leasing assistance" , image: cps3step6},
    ],
  },
  {
    id: 4,
    title: "SPV & Captive Rules",
    steps: [
      { title: "SPV incorporation support" , image: cps4step1},
      { title: "Structuring 26% equity + 51% consumption rule" , image: cps4step2},
      { title: "Shareholding pattern design for multiple captive users" , image: cps4step3},
      { title: "Drafting shareholder agreements, MoUs, compliance deeds" , image: cps4step4},
      { title: "Ensuring state-wise captive compliance alignments" , image: cps4step5},
      { title: "Investor onboarding documents" , image: cps4step6},
    ],
  },
  {
    id: 5,
    title: "Regulatory Approvals",
    steps: [
      { title: "DISCOM No-Objection Certificate (NOC)" , image: cps5step1},
      { title: "SLDC approvals for scheduling & forecasting" , image: cps5step2},
      { title: "CEIG/CEA compliance preparation" , image: cps5step3},
      { title: "Open access application filing" , image: cps5step4},
      { title: "Banking/wheeling rule mapping" , image: cps5step5},
      { title: "All approval timelines tracked inside TrueTrack™ for clients" , image: cps5step6},
      { title: "Auto-generated alerts for pending documents" , image: cps5step7},
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final SLDs, layouts, inverter & transformer sizing" , image: cps6step1},
      { title: "SCADA architecture design (with grid integration points)" , image: cps6step2},
      { title: "Module, inverter, transformer, MMS vendor locking" , image: cps6step3},
      { title: "Procurement scheduling & dispatch tracking" , image: cps6step4},
      { title: "QA/QC documentation for all critical components" , image: cps6step5},
      { title: "Logistics mapping & storage planning" , image: cps6step6},
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily construction logs: civil, MMS, DC, AC progress" , image: cps7step1},
      { title: "Live photos, videos & manpower logs" , image: cps7step2},
      { title: "Milestone % completion with predictive delay alerts" , image: cps7step3},
      { title: "Material consumption tracking" , image: cps7step4},
      { title: "Real-time comparison: planned vs actual timeline" , image: cps7step5},
      { title: "Safety & quality audits logged digitally" , image: cps7step6},
      { title: "Client dashboard for full transparency" , image: cps7step7},
    ],
  },
  {
    id: 8,
    title: "Testing & Sync",
    steps: [
      { title: "Pre-commissioning tests (string, insulation, transformer tests)" , image: cps8step1},
      { title: "ABT meter installation & sealing" , image: cps8step2},
      { title: "Grid protection relay testing" , image: cps8step3},
      { title: "Trial run generation & stability checks" , image: cps8step4},
      { title: "CEIG approvals & energization certificate" , image: cps8step5},
      { title: "Handover to O&M with baseline performance benchmarks" , image: cps8step6},
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "24/7 SCADA-based generation monitoring" , image: cps9step1},
      { title: "Real-time CUF, PR, inverter/stream analytics" , image: cps9step2},
      { title: "Grid outages, instability & export limitation alerts" , image: cps9step3},
      { title: "AI-driven fault detection & predictive maintenance" , image: cps9step4},
      { title: "Weather, soiling & degradation modelling" , image: cps9step5},
      {
        title: "Dual dashboards:", image: cps9step6,
        bullets: [
          "Engineering dashboard: SCADA, fault logs, telemetry",
          "Owner/CFO dashboard: uptime, savings, export trends",
        ],
      },
    ],
  },
  {
    id: 10,
    title: "O&M and Asset Health",
    steps: [
      { title: "Preventive maintenance planner (cleaning, tightening, transformer servicing)" , image: cps10step1},
      { title: "Corrective ticketing with SLA-based escalation" , image: cps10step2},
      { title: "Drone & thermography inspections" , image: cps10step3},
      { title: "Fault classification, root cause analysis, solution logging" , image: cps10step4},
      { title: "Downtime tracking & availability reporting" , image: cps10step5},
      { title: "Monthly digital health reports with PR/CUF deviation analysis" , image: cps10step6},
    ],
  },
  {
    id: 11,
    title: "Billing & OA Settlement",
    steps: [
      { title: "Monthly captive consumption billing" , image: cps11step1},
      { title: "SLDC schedule vs actual reconciliation" , image: cps11step2},
      { title: "Banking, wheeling & cross-subsidy application" , image: cps11step3},
      { title: "ABT meter data integration & settlement statements" , image: cps11step4},
      { title: "Energy accounting for all captive users" , image: cps11step5},
      { title: "Automated reminders for approvals, payments & filings" , image: cps11step6},
      { title: "Ensuring 51% consumption compliance across users" , image: cps11step7},
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Portfolio dashboards for multi-site captives" , image: cps12step1},
      { title: "Investor performance insights: IRR, ROI, payback" , image: cps12step2},
      { title: "Captive compliance documentation & annual filings" , image: cps12step3},
      { title: "Carbon credit eligibility (REC / I-REC / VER)" , image: cps12step4},
      { title: "Yearly performance benchmarking" , image: cps12step5},
      { title: "Long-term asset optimization recommendations" , image: cps12step6},
      { title: "Exportable reports for CFOs, auditors, and financial institutions" , image: cps12step7},
    ],
  },
];

const CAPTIVE_N = captiveStages.length;
const CAPTIVE_RADIUS = 380;
const CAPTIVE_ANGLE_STEP = 30;
const CAPTIVE_MINOR_TICKS = 72;

const HowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);

  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".cap-hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * CAPTIVE_N;
      const activeFloat = Math.min(arcFloat, CAPTIVE_N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * CAPTIVE_ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      captiveStages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * CAPTIVE_ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, CAPTIVE_N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = captiveStages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;
  const stepImages = [finalStep1, finalStep2, finalStep3];

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="cap-hiw-outer"
      ref={sectionRef}
      style={{ height: `${captiveStages.length * 110}vh` }}
    >
      <div className="cap-hiw-header-wrap">
        <div className="cap-hiw-tag">
          <span className="cap-hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="cap-hiw-title">
          True 360° Execution —<br />
          Zero-Stress, End-to-End Solar
        </h2>
        <p className="cap-hiw-subtitle">
          A transparent, predictable, 12-stage execution framework that ensures
          every captive solar project is delivered with absolute clarity and control.
        </p>
      </div>

      <div className="cap-hiw-sticky">
        <div className="cap-hiw-split">
          <div className="cap-hiw-left">
            <div className="cap-hiw-mobile-header">
              <div className="cap-hiw-tag">
                <span className="cap-hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="cap-hiw-title">
                True 360° Execution —<br />
                Zero-Stress, End-to-End Solar
              </h2>
              <p className="cap-hiw-subtitle">
                A transparent, predictable, 12-stage execution framework that
                ensures every captive solar project is delivered with absolute
                clarity and control.
              </p>
            </div>

            <div className="cap-hiw-dial-wrapper">
              <div className="cap-hiw-dial-container" ref={dialRef}>
                <div className="cap-hiw-dial-bg"></div>
                <div className="cap-hiw-dial-inner-orange"></div>

                {Array.from({ length: CAPTIVE_MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="cap-hiw-dial-tick-min"
                    style={{
                      transform: `rotate(${i * (360 / CAPTIVE_MINOR_TICKS)}deg) translate(${CAPTIVE_RADIUS}px)`,
                    }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {captiveStages.map((stage, i) => {
                  const itemAngle = i * CAPTIVE_ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`cap-hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${CAPTIVE_RADIUS}px)` }}
                      />
                      <div
                        className={`cap-hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${CAPTIVE_RADIUS + 40}px)` }}
                      >
                        <div
                          className="cap-hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="cap-hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="cap-hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="cap-hiw-dial-pointer"></div>
              </div>

              <div className="cap-hiw-active-overlay">
                <div className="cap-hiw-inner-faint-line"></div>
                <div className="cap-hiw-active-thick-line"></div>
                <div className="cap-hiw-active-dot"></div>
                <div className="cap-hiw-active-text-block">
                  <span className="cap-hiw-active-num">{numStr}</span>
                  <span className="cap-hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="cap-hiw-mobile-info">
              <div className="cap-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="cap-hiw-mobile-title">{currentStage.title}</h3>
              <p className="cap-hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button
                className="cap-hiw-mobile-view-btn"
                onClick={() => setIsMobilePopupOpen(true)}
              >
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          <div className={`cap-hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="cap-hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="cap-hiw-popup-inner">
              <button className="cap-hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="cap-hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="cap-hiw-right-title">{currentStage.title}</h2>

              <div className="cap-hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="cap-hiw-step-card">
                    <div className="cap-hiw-step-img-wrap">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="cap-hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="cap-hiw-step-text">
                      <p className="cap-hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="cap-hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="cap-hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="cap-hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="cap-hiw-nav-arrows">
                <button type="button" className="cap-hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button type="button" className="cap-hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="cap-hiw-popup-mobile-info">
                <div className="cap-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="cap-hiw-mobile-title">{currentStage.title}</h3>
                <p className="cap-hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button className="cap-hiw-mobile-view-btn popup-btn" onClick={() => setIsMobilePopupOpen(false)}>
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 7 — WHY CHOOSE US
   ================================================ */
const CaptiveWhyChooseUs = () => {
  const leftCards = [
    {
      num: "01",
      text: "Specialized team for captive and regulatory compliance.",
    },
    { num: "02", text: "Proven execution across multi-MW C&I projects." },
    { num: "03", text: "Integrated digital ecosystem for 360° transparency." },
  ];
  const rightCards = [
    {
      num: "04",
      text: "Strong relationships with DISCOMs, SLDCs, and government bodies.",
    },
    {
      num: "05",
      text: "Transparent execution, premium quality, and robust engineering.",
    },
    { num: "06", text: "End-to-end lifecycle support (25+ years)." },
  ];

  return (
    <section className="captive-why">
      {/* Header */}
      <div className="captive-why-header">
        <p className="captive-why-tag">
          <span className="captive-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="captive-why-title">
          Captive Expertise. Execution You Can Trust.
        </h2>
      </div>

      {/* Body */}
      <div className="captive-why-body">
        {/* Left cards */}
        <div className="captive-why-col">
          {leftCards.map((c) => (
            <div className="captive-why-card" key={c.num}>
              <p className="captive-why-num">{c.num}</p>
              <p className="captive-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        {/* Center image */}
        <div className="captive-why-img-wrap">
          <img
            src={chooseImg}
            alt="Why Choose Us"
            className="captive-why-img"
            loading="lazy"
          />
        </div>

        {/* Right cards */}
        <div className="captive-why-col">
          {rightCards.map((c) => (
            <div className="captive-why-card" key={c.num}>
              <p className="captive-why-num">{c.num}</p>
              <p className="captive-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 8 — FEATURED PROJECTS
   ================================================ */
const CaptiveFeaturedProjects = () => {
  const projects = [
    {
      img: featuredproj1,
      title: "Manufacturing Captive Solar Plant – Gujarat",
      desc: "A 5 MW off-site captive solar plant developed for a leading textile manufacturer reducing grid dependency by over 60%.",
      tags: ["Gujarat", "5 MW", "TEXTILE Industry"],
    },
    {
      img: featuredproj2,
      title: "Automotive Components Captive Solar Facility",
      desc: "A 3.2 MW captive solar installation improved EBITDA margins for a Tier-1 automotive supplier.",
      tags: ["Maharashtra", "Automotive", "3.2 MW"],
    },
  ];

  return (
    <section className="captive-proj-section">
      <div className="captive-proj-header">
        <p className="captive-proj-tag">
          <span className="captive-proj-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="captive-proj-title">
          Industrial Energy Independence in Action
        </h2>
      </div>

      <div className="captive-proj-grid">
        {projects.map((p, i) => (
          <div className="captive-proj-card" key={i}>
            <div className="captive-proj-img-wrap">
              <img src={p.img} alt={p.title} className="captive-proj-card-img" loading="lazy" />
            </div>
            <div className="captive-proj-card-body">
              <h3 className="captive-proj-card-title">{p.title}</h3>
              <p className="captive-proj-card-desc">{p.desc}</p>
              <div className="captive-proj-tags">
                {p.tags.map((tag, j) => (
                  <span className="captive-proj-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    5. TESTIMONIALS
//    ================================================ */
// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote:
//         '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote:
//         '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote:
//         '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',

//       photo: Testi3,
//     },
//   ];

//   // ── TESTIMONIAL CARD ──
//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`testi-card ${animClass || ""}`}>
//       <div className="testi-card-content">
//         <div className="testi-person">
//           <div>
//             <p className="testi-name">{item.name}</p>
//             <p className="testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="testi-divider" />
//         <p className="testi-quote">{item.quote}</p>
//       </div>
//       <div className="testi-card-photo">
//         {item.photo ? (
//           <img src={item.photo} alt={item.name} className="testi-photo" />
//         ) : (
//           <div className="testi-photo-placeholder" />
//         )}
//       </div>
//     </div>
//   );

//   const ChevronLeft = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const headerRef = useReveal();
//   const total = testimonials.length;

//   const prev = () => {
//     setSlideDir("testi-slide-left");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c - 1 + total) % total);
//   };

//   const next = () => {
//     setSlideDir("testi-slide-right");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c + 1) % total);
//   };

//   return (
//     <section className="testi-section">
//       <div className="testi-header reveal-block" ref={headerRef}>
//         <div className="testi-header-left">
//           <p className="testi-tag">
//             <span className="testi-dot"></span> TESTIMONIALS
//           </p>
//           <h2 className="testi-title">
//             Trusted By Clients Across
//             <br />
//             Industries
//           </h2>
//         </div>
//         <div className="testi-header-right">
//           <p className="testi-subtitle">
//             Real experiences from clients who trust us
//             <br />
//             with their solar journey.
//           </p>
//           <div className="testi-arrows testi-arrows-header">
//             <button
//               className="testi-arrow"
//               onClick={prev}
//               aria-label="Previous testimonial"
//             >
//               <ChevronLeft />
//             </button>
//             <button
//               className="testi-arrow"
//               onClick={next}
//               aria-label="Next testimonial"
//             >
//               <ChevronRight />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="testi-cards" key={animKey}>
//         <TestimonialCard
//           item={testimonials[current % total]}
//           animClass={slideDir}
//         />
//         <TestimonialCard
//           item={testimonials[(current + 1) % total]}
//           animClass={`${slideDir} testi-delay`}
//         />
//       </div>
//     </section>
//   );
// };

/* ======================================================
   MAIN COMPONENT
====================================================== */
function CaptiveModel() {
  useEffect(() => {
    document.body.classList.add("captive-page");

    return () => {
      document.body.classList.remove("captive-page");
    };
  }, []);

  return (
    <div>
      <HeroSection />
      <OverviewSection />
      <ExplainerSection />
      <RegulatorySection />
      <FinancialBenefits />
      <CaptiveWhoItsFor />
      <HowItWorks />
      <CaptiveWhyChooseUs />
      <CaptiveFeaturedProjects />
      {/* <Testimonials /> */}
    </div>
  );
}

export default CaptiveModel;
